/* eslint no-console: 1 */
import Axios from 'axios'
import baseService from './baseService'

const relaticsService = {
	async getInvoices(relaticsKey: any) {
		const config = baseService.generateConfigData()
		const payload = {
			relaticsKey: relaticsKey
		}
		try {
			return await Axios.post(
				`${import.meta.env.VITE_APP_API_URL}relatics/getInvoices`,
				payload,
				config
			)
		} catch (error) {
			return error
		}
	},
	async getPortalWoningData(relaticsKey: any) {
		const config = baseService.generateConfigData()
		const payload = {
			relaticsKey: relaticsKey
		}
		try {
			return await Axios.post(
				`${import.meta.env.VITE_APP_API_URL}relatics/getPortalWoningData`,
				payload,
				config
			)
		} catch (error) {
			return error
		}
	},
	async getPortalPerceelData(relaticsKey: any) {
		const config = baseService.generateConfigData()
		const payload = {
			relaticsKey: relaticsKey
		}
		try {
			return await Axios.post(
				`${import.meta.env.VITE_APP_API_URL}relatics/getPortalPerceelData`,
				payload,
				config
			)
		} catch (error) {
			return error
		}
	},
	async getUser(relaticsKey: any) {
		const config = baseService.generateConfigData()
		const payload = {
			relaticsKey: relaticsKey
		}
		try {
			return await Axios.post(
				`${import.meta.env.VITE_APP_API_URL}relatics/getUser`,
				payload,
				config
			)
		} catch (error) {
			return error
		}
	},
	async getFile(fileGUID: any) {
		const config = baseService.generateConfigData()
		const payload = {
			fileGUID: fileGUID
		}
		try {
			return await Axios.post(
				`${import.meta.env.VITE_APP_API_URL}relatics/getFile`,
				payload,
				config
			)
		} catch (error) {
			return error
		}
	},
	async updateWoningAccordering(GUID: any) {
		const config = baseService.generateConfigData()
		const payload = {
			GUID: GUID
		}
		try {
			return await Axios.post(
				`${import.meta.env.VITE_APP_API_URL}relatics/updateWoningAccordering`,
				payload,
				config
			)
		} catch (error) {
			return error
		}
	},
	async updatePerceelAccordering(GUID: any) {
		const config = baseService.generateConfigData()
		const payload = {
			GUID: GUID
		}
		try {
			return await Axios.post(
				`${import.meta.env.VITE_APP_API_URL}relatics/updatePerceelAccordering`,
				payload,
				config
			)
		} catch (error) {
			return error
		}
	},
	async uploadWijzigen(
		relaticsKey: any,
		category: any,
		organisation: string,
		organisationNumber: string,
		parceel: string,
		reden: string,
		file: any,
		fileName: any,
		fileType: any,
		datum: string
	) {
		const config = baseService.generateConfigData()
		const payload = {
			relaticsKey: relaticsKey,
			category: category,
			organisation: organisation,
			organisationNumber: organisationNumber,
			perceel: parceel,
			reden: reden,
			file: file,
			fileName: fileName,
			fileType: fileType,
			datum: datum
		}
		try {
			return await Axios.post(
				`${import.meta.env.VITE_APP_API_URL}relatics/uploadWijzigen`,
				payload,
				config
			)
		} catch (error) {
			return error
		}
	},
	async uploadPerceelWijzigen(
		relaticsKey: any,
		category: any,
		organisatie: string,
		perceel: string,
		reden: string,
		file: null,
		fileName: null,
		fileType: null,
		data: string,
		dataH: string
	) {
		const config = baseService.generateConfigData()
		const payload = {
			relaticsKey: relaticsKey,
			category: category,
			organisatie: organisatie,
			perceel: perceel,
			reden: reden,
			file: file,
			fileName: fileName,
			fileType: fileType,
			data: data,
			dataH: dataH
		}
		try {
			return await Axios.post(
				`${import.meta.env.VITE_APP_API_URL}relatics/uploadPerceelWijzigen`,
				payload,
				config
			)
		} catch (error) {
			return error
		}
	},
	async updateVergoedingGaatNaar(
		relaticsKey: any,
		newOrganisation: any,
		parceel: string,
		reden: string
	) {
		const config = baseService.generateConfigData()
		const payload = {
			relaticsKey: relaticsKey,
			newOrganisation: newOrganisation,
			parceel: parceel,
			reden: reden
		}
		try {
			return await Axios.post(
				`${import.meta.env.VITE_APP_API_URL}relatics/updateVergoedingGaatNaar`,
				payload,
				config
			)
		} catch (error) {
			return error
		}
	},
	async updatePhoneNumber(relaticsKey: any, phoneNumber: string) {
		const config = baseService.generateConfigData()
		const payload = {
			relaticsKey: relaticsKey,
			phoneNumber: phoneNumber
		}
		try {
			return await Axios.post(
				`${import.meta.env.VITE_APP_API_URL}relatics/updatePhoneNumber`,
				payload,
				config
			)
		} catch (error) {
			return error
		}
	},
	async updateEmail(relaticsKey: any, email: string, code: string) {
		const config = baseService.generateConfigData()
		const payload = {
			relaticsKey: relaticsKey,
			email: email,
			validationCode: code
		}
		try {
			return await Axios.post(
				`${import.meta.env.VITE_APP_API_URL}relatics/updateEmail`,
				payload,
				config
			)
		} catch (error) {
			return error
		}
	},
	async updateEmailRequest(relaticsKey: any, email: string) {
		const config = baseService.generateConfigData()
		const payload = {
			relaticsKey: relaticsKey,
			email: email
		}
		try {
			return await Axios.post(
				`${import.meta.env.VITE_APP_API_URL}relatics/updateEmailRequest`,
				payload,
				config
			)
		} catch (error) {
			return error
		}
	},
	async updateUserPassword(relaticsKey: any, currentPassword: string, newPassword: string) {
		const config = baseService.generateConfigData()
		const payload = {
			relaticsKey: relaticsKey,
			currentPassword: currentPassword,
			newPassword: newPassword
		}
		try {
			return await Axios.post(
				`${import.meta.env.VITE_APP_API_URL}relatics/updateUserPassword`,
				payload,
				config
			)
		} catch (error) {
			return error
		}
	}
}

export default relaticsService
